import './styles.scss'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Button, DropdownItem, DropdownMenu, DropdownToggle, Spinner, UncontrolledDropdown, UncontrolledTooltip, Collapse } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import axios from 'axios'

import { botConsole, apiSchedules, SmartChatEcommerceAPI, EcommerceAPI, smartChat } from 'api'
import ConsoleQuestion from 'components/ConsoleQuestion'
import ScheduleModal from 'components/ScheduleModal'
import PhoneViewer from 'components/PhoneViewer'
import { Button as FormButton } from 'components/Form'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import CategoryModal from './CategoryModal'
import VACard from './VACard'
import TranslateCard from './TranslateCard'
import ModalWrapper from 'components/ModalWrapper'
import AVBanner from './VABanner'
import SmartChatActivationModal from './SmartChatActivationModal'
import TranslationConfigModal from './TranslationConfigModal'
import AmbiguityConfigModal from './AmbiguityConfigModal'
import CredentialsConfigModal from './CredentialsConfigModal'
import { getStaticImage } from 'utils/statics'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import { validateShorcutsAV } from 'utils/helpers'
import { useIntersection } from 'hooks'
import { ALLOWED_DOMAINS } from 'constants/index'
import moduleActions from 'redux/modules/actions'
import GeneratedResponsesModal from './GeneratedResponsesModal'
import { LangSelector } from 'components/common'
import flagEnvDisplay from 'constants/flagEnvDisplay'
import Checkbox from 'components/Checkbox'
import ModalDelete from 'components/ModalDelete'

const _ = require('lodash')

const AssistantView = (props) => {
  const dispatch = useDispatch()
  const { location } = useHistory()
  const [botHeader, setBotHeader] = React.useState(props.botHeader)
  const [modal, setModal] = React.useState(false)
  const [isOpenSmartChatHealtModal, setIsOpenSmartChatHealtModal] = React.useState(false)
  const [isOpenSmartChatActivationModal, setIsOpenSmartChatActivationModal] = React.useState(false)
  const [smartChatHealtInfo, setSmartChatHealtInfo] = React.useState('')
  const [smartChatChecked, setSmartChatChecked] = React.useState(false)
  const [checked, setChecked] = React.useState(false)
  const [generativeChecked, setGenerativeChecked] = React.useState(false)
  const [assistedAIChecked, setAssistedAIChecked] = React.useState(false)
  const [automaticTranslateChecked, setAutomaticTranslateChecked] = React.useState(false)
  const [isMultiIntent, setIsMultiIntent] = React.useState(false)
  const [isGroupable, setIsGroupable] = React.useState(false)
  const [ambiguity, setAmbiguity] = React.useState(false)
  const [questions, setQuestions] = React.useState([])
  const [intents, setIntents] = React.useState([])
  const [schedules, setSchedules] = React.useState({})
  const [questionsOpened, setQuestionsOpened] = React.useState([])
  const [newQuestionOpen, setNewQuestionOpen] = React.useState([])
  const [questionLabelText, setQuestionLabelText] = React.useState('')
  const [questionLabelTextTA, setQuestionLabelTextTA] = React.useState('')
  const [hasEditIntents, setHasEditIntents] = React.useState(false)
  const [activeModal, setActiveModal] = React.useState('train')
  const company = useSelector((store) => store.companies)
  const smartChatModule = useSelector((store) => store.modules.smartChat)
  const smartChatEcommerceModule = useSelector((store) => store.modules.smartChatEcommerce)
  const [textPreview, setTextPreview] = React.useState({})
  const [onPreview, setOnPreview] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const [stateFaqViewControl, setStateFaqViewControl] = React.useState([{ category: 'none', categoryOrder: 0, intentList: [] }])
  const [showModalCategory, setShowModalCategory] = React.useState(false)
  const [goToTop, setGoToTop] = React.useState(false)
  const [counterQuestions, setCounterQuestions] = React.useState([])
  const totalQuestions = 5
  const initialQuestions = 3
  const [notShow, setNotShow] = React.useState(false)
  const [popupTrainIsOpen, setPopupTrainIsOpen] = React.useState(false)
  const [isFirstTime, setIsFirstTime] = React.useState(true)
  const [currentChannelPreview, setCurrentChannelPreview] = React.useState(undefined)
  const [categoryModalMode, setCategoryModalMode] = React.useState('')
  const [categoryForEdit, setCategoryForEdit] = React.useState('')
  const [isOpenTranslationConfigModal, setIsOpenTranslationConfigModal] = React.useState(false)
  const [isOpenAmbiguityConfigModal, setIsOpenAmbiguityConfigModal] = React.useState(false)
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [removing, setRemoving] = React.useState(false)
  const [funcLetterInput, setFuncLetterInput] = React.useState('')
  const [entry, setNode] = useIntersection({})
  const [smartChatEcommerceChecked, setSmartChatEcommerceChecked] = React.useState(false)
  const [isOpenCredentialConfigModal, setIsOpenCredentialConfigModal] = React.useState(false)
  const [ecommerceMessageModal, setEcommerceMessageModal] = React.useState('')
  const [isCredentialConfig, setIsCredentialConfig] = React.useState(false)
  const [faqTitle, setFaqTitle] = React.useState('')
  const [answerListObj, setAnswerListObj] = React.useState([])
  const [smartchatProcesses, setSmartchatProcesses] = React.useState([])
  const [isLoadingProcesses, setIsLoadingProcesses] = React.useState(false)
  const [isOpenGeneratedResponsesModal, setIsOpenGeneratedResponsesModal] = React.useState(false)
  const [answerLang, setAnswerLang] = React.useState(flagEnvDisplay.displayMultiLang ? '' : 'es')
  const [isOpenDeleteModal, setIsOpenDeleteModal] = React.useState(false)
  const [currentDeleteCategory, setCurrentDeleteCategory] = React.useState('')

  React.useEffect(() => {
    getSmartchatProcesses()
  }, [])

  React.useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (isFirstTime) setPopupTrainIsOpen(botHeader.popupTrainResult === 'no_popup' ? false : true)

      if (botHeader.faqViewControl.length) {
        if (!stateFaqViewControl.some(it => it.category === 'none')) {
          setStateFaqViewControl(state => ([...state, ...botHeader.faqViewControl]))
        } else {
          setStateFaqViewControl(botHeader.faqViewControl)
        }
      }

      setSmartChatChecked(botHeader.smartChat)
      setChecked(botHeader.isActive)
      setGenerativeChecked(botHeader.generative)
      setAssistedAIChecked(botHeader.operatorAssistance)
      setAutomaticTranslateChecked(botHeader.automaticTranslation)
      setIsMultiIntent(botHeader.isMultiIntent)
      setIsGroupable(botHeader.isGroupable)
      setAmbiguity(botHeader.ambiguity)
      // setHasEditIntents(botHeader.applyPending && botHeader.modelStatus === 'PENDING')
      setHasEditIntents(botHeader.applyPending)
      setSmartChatEcommerceChecked(botHeader.eCommerce)
      getIntents()
      setQuestionLabelText(`👇 ${I18n.t('faq_console_question_add_tutorial_first')}`)
      setQuestionLabelTextTA(`👇 ${I18n.t('faq_console_question_tutorial_review_ta')}`)

      getSchedules()
    }

    return () => isSubscribed = false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botHeader])

  React.useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && stateFaqViewControl.length) setCounterQuestionsByCategory(stateFaqViewControl)

    return () => isSubscribed = false
  }, [stateFaqViewControl])

  React.useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (intents.length) {
        setQuestionsOpened(() => {
          return intents.map(() => {
            return false
          })
        })
      }

      setQuestions(intents)
    }

    return () => isSubscribed = false
  }, [intents])

  React.useEffect(() => {
    if (location.hash && questions?.length) {
      const hash = location.hash.replace('#', '')
      if (questions.some(it => it._id === hash)) props.setFaqToScroll(hash)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions])

  React.useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && goToTop) {
      document.getElementById('refContainer').scrollTo({ behavior: 'smooth', top: 0 })
      setGoToTop(false)
    }

    return () => isSubscribed = false
  }, [goToTop])

  const toggleTranslationConfigModal = () => setIsOpenTranslationConfigModal(!isOpenTranslationConfigModal)

  const toggleAmbiguityConfigModal = () => setIsOpenAmbiguityConfigModal(!isOpenAmbiguityConfigModal)

  const onToggleModalCategory = ({ mode, categoryName }) => {
    if (mode) {
      setCategoryModalMode(mode)
    } else {
      setCategoryModalMode('')
    }

    if (categoryName) {
      setCategoryForEdit(categoryName)
    } else {
      setCategoryForEdit('')
    }

    setShowModalCategory(!showModalCategory)
  }

  const toggleSmartChatHealthModal = () => setIsOpenSmartChatHealtModal(!isOpenSmartChatHealtModal)

  const toggleOpenSmartChatActivationModal = () => setIsOpenSmartChatActivationModal(!isOpenSmartChatActivationModal)

  const toggleGeneratedResponsesModal = () => {
    if (isOpenGeneratedResponsesModal) {
      props.getBotHeader()
    }
    setIsOpenGeneratedResponsesModal(prevState => !prevState)
  }

  const updateBotHeader = async (id, data) => {
    const result = await botConsole.updateBotHeader(id, data)
    if (result.status === 200) {
      setBotHeader(state => ({
        ...state,
        ...data
      }))
    }
  }

  const checkSmartChatModule = async (botId) => {
    const isActiveNow = !!(smartChatModule.isActive && smartChatChecked)

    if (!isActiveNow) {
      const { data: { result: healthStatus } } = await botConsole.getSmartChatHealth(botId)

      if (healthStatus === 1 || healthStatus === 2) {
        setSmartChatHealtInfo('botConsole_smartChat_healtInfo_notPassed')
        return toggleSmartChatHealthModal()
      }

      if (healthStatus === 3 || healthStatus === 4) {
        setSmartChatHealtInfo('botConsole_smartChat_healtInfo_insufficientData')
        return toggleSmartChatHealthModal()
      }

      healthStatus === 0 && !smartChatModule.isActive
        ? toggleOpenSmartChatActivationModal()
        : toggleActivateSmartChat()
    } else {
      toggleActivateSmartChat()
    }
  }

  const toggleActivateSmartChat = async () => {
    const isChecked = !!(smartChatModule.isActive && smartChatChecked)

    await updateBotHeader(botHeader._id, { smartChat: !isChecked })

    setSmartChatChecked(!isChecked)
  }

  const getSmartchatProcesses = () => {
    setIsLoadingProcesses(true)

    smartChat.getProcessesPartialList(
      null,
      { processType: ['assistant','conversational','transactional'] }
    )
      .then(({ data }) => {
        setSmartchatProcesses(data)
      })
      .finally(() => {
        setIsLoadingProcesses(false)
      })

  }

  const addNewQuestion = async (category) => {
    let questions = []
    const firstText = document.getElementById('firstFormulation')?.value || ''
    const secondText = document.getElementById('secondFormulation')?.value || ''
    const thirdText = document.getElementById('thirdFormulation')?.value || ''
    const fourthText = document.getElementById('fourthFormulation')?.value || ''
    const fifthText = document.getElementById('fifthFormulation')?.value || ''
    if (firstText) questions.push(firstText)
    if (secondText) questions.push(secondText)
    if (thirdText) questions.push(thirdText)
    if (fourthText) questions.push(fourthText)
    if (fifthText) questions.push(fifthText)
    const answer = textPreview
    const shortcut = document.getElementById('funcLetterInput')?.value

    if (!errorChecking({ questions, shortcut })) return

    const values = {
      id: `_${Math.random().toString(36).substr(2, 9)}`,
      faqTitle: questions[0],
      keyboardShortcut: shortcut.replace(/ +/g, ""),
      reformulationList: questions.map((question) => {
        return { es: question }
      }),
      answerList: [
        { [answerLang]: { ...answer, type: 'default' } }
      ],
      category: category
    }
    if(ALLOWED_DOMAINS.type === 'TA') values.suggestion = true

    setIsSubmitting(true)
    const { data } = await botConsole.saveIntent(botHeader._id, values)
    setIsSubmitting(false)
    setNewQuestionOpen([])
    setFuncLetterInput('')

    //ASIGNAR NUEVO INTENT A CATEGORIA
    let _stateFaqViewControl = _.clone(stateFaqViewControl)
    if (_stateFaqViewControl.some(it => it.category === category)) {
      if (data.results._id) {
        _stateFaqViewControl.forEach(it => {
          if (it.category === category) {
            if (!it.intentList.includes(data.results._id))
              it.intentList.push(data.results._id)
          }
        })
      }
    }
    setStateFaqViewControl(_stateFaqViewControl)
    updateBotHeader(botHeader._id, { faqViewControl: _stateFaqViewControl })
  }

  const openEditQuestion = async (intentId) => {
    const { data } = await botConsole.getIntentDetail(botHeader._id, intentId)
    const { faqTitle, answerList } = data.results
    let newQuestionOpened = new Array(questionsOpened.length).fill(false)
    const intent = questions.find(question => question._id === intentId)
    const index = questions.indexOf(intent)
    newQuestionOpened[index] = true
    setQuestionsOpened(newQuestionOpened)
    setNewQuestionOpen([])
    setFaqTitle( faqTitle || '' )
    setAnswerListObj(answerList)
    return data.results
  }

  const getIntents = async () => {
    const { data } = await botConsole.getIntents(botHeader._id)

    setStateFaqViewControl(state => ([
      ...state.map(elem => {
        elem.intentList = data.results.filter(q => elem.category === q.category)
          .map(elem => elem._id)
        return elem
      })
    ]))

    setIntents(data.results)
  }

  const getSchedules = async () => {
    const data = await apiSchedules.get({
      tag: ['automaticResponsesVA', 'operatorAssistantVA', 'smartChat'],
      group: ['virtualAssistant'],
      createdTo: [botHeader._id]
    })

    setSchedules({ automaticResponsesVA: data[0], operatorAssistantVA: data[1], assistant: data[2] })
  }

  const saveSchedules = async (automaticResponsesVA, operatorAssistantVA, assistant) => {
    const data = [
      { ...schedules.automaticResponsesVA, group: 'virtualAssistant', tag: 'automaticResponsesVA', schedule: automaticResponsesVA },
      { ...schedules.operatorAssistantVA, group: 'virtualAssistant', schedule: operatorAssistantVA },
      { ...schedules.assistant, group: 'virtualAssistant', schedule: assistant }
    ]

    await apiSchedules.post({ schedules: data })

    setSchedules({ automaticResponsesVA: data[0], operatorAssistantVA: data[1], assistant: data[2] })
  }

  const trainBot = async () => {
    try {
      const result = await botConsole.trainBot(botHeader._id)
      if (result.status === 200) {
        const { data } = await botConsole.getBotHeader(botHeader._id)
        setBotHeader(data)
        setHasEditIntents(false)
        toggle()
      }
    } catch (error) {
      if (error.flow) {
        toggle()
      }
    }
  }

  const toggle = () => {
    setModal(!modal)
  }

  const setCounterQuestionsByCategory = (categories = []) => {
    let _counterQuestions = []
    categories.forEach(it => {
      _counterQuestions.push({ category: it.category, counter: initialQuestions })
    })
    setCounterQuestions(_counterQuestions)
  }

  const updateInputText = () => {
    const firstText = document.getElementById('firstFormulation').value
    const secondText = document.getElementById('secondFormulation').value
    if (firstText === '' && secondText === '') {
      setQuestionLabelText(`👇 ${I18n.t('faq_console_question_add_tutorial_first')}`)
    } else if ((firstText !== '' && secondText === '') || (firstText === '' && secondText !== '')) {
      setQuestionLabelText(`👍 ${I18n.t('faq_console_question_add_tutorial_second')}`)
    } else if (firstText !== '' && secondText !== '') {
      setQuestionLabelText(`👏 ${I18n.t('faq_console_question_add_tutorial_third')}`)
    }
  }

  const deleteQuestion = async (questionId, category) => {
    setRemoving(true)

    const result = await botConsole.deleteIntent(botHeader._id, questionId)

    // ELIMINAR INTENT DE UNA CATEGORIA
    if (result.status === 200) {
      if (stateFaqViewControl.some(it => it.category === category)) {
        let newQuestionList = stateFaqViewControl.find(q => q.category === category).intentList
        newQuestionList.splice(newQuestionList.findIndex(it => it === questionId), 1)
        let _stateFaqViewControl = _.clone(stateFaqViewControl)
        _stateFaqViewControl.find(it => it.category === category).intentList = newQuestionList
        setStateFaqViewControl(_stateFaqViewControl)
        updateBotHeader(botHeader._id, { faqViewControl: _stateFaqViewControl })
      }
    }

    setRemoving(false)
  }

  const changeQuestionStatus = async (questionId, status) => {
    await botConsole.updateIntentStatus(botHeader._id, questionId, { isActive: status })
  }

  const updateIntent = async (questionId, questionList, answerLang, answer, shortcut, questionsChanged) => {
    let answerList = answerListObj
    answerList[0][answerLang] = answer
    answerList[0][answerLang].type = Object.keys(answerList[0]).length > 1 ? 'operator' : 'default'
    const data = {
      id: questionId,
      faqTitle: ALLOWED_DOMAINS.type === 'TA' && faqTitle ? faqTitle : questionList[0],
      reformulationList: questionList.map((question) => {
        return {
          es: question,
        }
      }),
      answerList,
      keyboardShortcut: shortcut,
      faqUpdated: questionsChanged,
    }

    const result = await botConsole.updateIntent(botHeader._id, questionId, data)
    if (result.status === 200) {
      getIntents()
    }
  }

  const inputContentChanged = (status, questionId) => {
    if (status) {
      setHasEditIntents(status)
    }
    let newQuestionOpened = new Array(questionsOpened.length).fill(false)
    setQuestionsOpened(newQuestionOpened)
  }

  const getModelStatus = () => {
    switch (botHeader.modelStatus) {
      case 'ONLINE':
        return (
          <div className='status-container'>
            <div className='fa fa-check check' />
            <div className='status-title'>{I18n.t('dashboard_generated-model')}</div>
          </div>
        )
      case 'PENDING':
      case 'ONGOING':
        return (
          <div className='options-training-container'>
            <div>
              <Spinner color='primary' />
            </div>
            <div className='options-training'>
              <div className='title'>{I18n.t('faq_console_status_training_title')}</div>
              <div className='subtitle'>{I18n.t('faq_console_status_training_subtitle')}</div>
            </div>
          </div>
        )
      default:
        return <div></div>
    }
  }

  const TrainBotModal = () => (
    <div className='modal-content'>
      <div className='modal-header'>
        <img className='robot-image' src={'/img/console-robot.svg'} alt='robot' />
        <div className='close' onClick={toggle}>
          <i className='fa fa-times' color='grey'></i>
        </div>
      </div>
      <div className='modal-body'>
        <div className='modal-title'>{I18n.t('faq_console_train_modal_title')}</div>
        <div className='modal-subtitle'>
          {botHeader.forceTrain
            ? I18n.t('faq_console_train_ambiguity_modal_subtitle_1')
            : I18n.t('faq_console_train_modal_subtitle_1')
          }
        </div>
        <div className='modal-subtitle'>{I18n.t('faq_console_train_modal_subtitle_2')}</div>
      </div>
      <div className='modal-footer'>
        <FormButton secondary value={I18n.t('faq_console_train_modal_button')} onClick={trainBot} />
        <FormButton value={I18n.t('dashboard_cancel')} onClick={toggle} />
      </div>
    </div>
  )

  const QuestionsThresholdModal = () => (
    <div className='questions-modal-content'>
      <div className='modal-body'>
        <div className='modal-title'>{I18n.t('faq_console_train_modal_title')}</div>
        <div className='modal-subtitle'>{I18n.t('faq_console_questions_threshold_modal_text')}</div>
      </div>
      <div className='modal-footer'>
        <FormButton secondary value={I18n.t('dashboard_ok')} onClick={toggle} />
      </div>
    </div>
  )

  const getModal = () => {
    switch (activeModal) {
      case 'train':
        return <TrainBotModal />
      case 'schedule':
        return <ScheduleModal scheduleMode='basic' closeModal={closeModal} schedules={[schedules.automaticResponsesVA.schedule, schedules.operatorAssistantVA.schedule, schedules.assistant.schedule]} saveSchedules={saveSchedules} />
      case 'questions':
        return <QuestionsThresholdModal />
      default:
        return <TrainBotModal />
    }
  }

  const openTrainModal = () => {
    if (questions.length >= 5) {
      setActiveModal('train')
    } else {
      setActiveModal('questions')
    }
    toggle()
  }

  const openSchedule = () => {
    if (Object.keys(schedules).length) {
      setActiveModal('schedule')
      toggle()
    }
  }

  const closeModal = () => {
    toggle()
  }

  const errorChecking = ({ questions }) => {
    if (questions?.length < 2) {
      setErrorMessage('Por favor, ingresa por lo menos dos formulaciones.')
      return false
    }

    if (!textPreview.content) {
      setErrorMessage('Por favor, ingresa una respuesta.')
      return false
    }

    if (flagEnvDisplay.displayMultiLang && !answerLang) {
      setErrorMessage('Por favor, selecciona el idioma de la respuesta.')
      return false
    }

    return true
  }

  const checkShortcut = (shortcut) => {
    if (intents.find(intent => intent.keyboardShortcut === shortcut)) {
      return true
    } else {
      return false
    }
  }

  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }

    // MOVIMIENTO DE PREGUNTA DENTRO DE LA MISMA CATEGORIA
    if (result.type === 'QUESTIONS') {
      const droppableIdDestination = result.destination.droppableId.replace(/ +/g, "")
      const droppableIdSource = result.source.droppableId.replace(/ +/g, "")
      let newQuestionList = stateFaqViewControl.find(q => q.category.replace(/\s+|\/|\\|\.|,/g, '') === droppableIdDestination).intentList  // .filter(i => i !== result.draggableId)
      let newQuestionListSource = stateFaqViewControl.find(q => q.category.replace(/\s+|\/|\\|\.|,/g, '') === droppableIdSource).intentList  // .filter(i => i !== result.draggableId)
      newQuestionListSource.splice(result.source.index, 1)
      newQuestionList.splice(result.destination.index, 0, result.draggableId)
      let _stateFaqViewControl = stateFaqViewControl
      _stateFaqViewControl.find(it => it.category.replace(/\s+|\/|\\|\.|,/g, '') === droppableIdDestination)['intentList'] = newQuestionList
      setStateFaqViewControl(_stateFaqViewControl)

      // ORDENAR LOS INTENTS
      let sorting = _.clone(newQuestionList)
      const resultQuestion = questions.map(function (item) {
        var n = sorting.indexOf(item._id)
        sorting[n] = ''
        return [n, item]
      }).sort().map(function (j) { return j[1] })
      setQuestions(resultQuestion)
      updateBotHeader(botHeader._id, { faqViewControl: _stateFaqViewControl })
    } else if (result.destination.droppableId === 'categories-list') {
      let category = stateFaqViewControl.find(it => it.categoryOrder === result.source.index)
      let _stateFaqViewControl = stateFaqViewControl.filter(it => it.categoryOrder !== result.source.index)
      _stateFaqViewControl.splice(result.destination.index, 0, category)
      _stateFaqViewControl.map((it, index) => it.categoryOrder = index)
      setStateFaqViewControl(_stateFaqViewControl)
      updateBotHeader(botHeader._id, { faqViewControl: _stateFaqViewControl })
    }

  }

  const question = (order) => {
    return (
      <div className='question-input-container animated fadeIn' key={order}>
        <p className='question-input-container__title'>
          {I18n.t(`dashboard_${order}-formulation`)}
        </p>
        <input
          id={`${order}Formulation`}
          className='question-input'
          placeholder={I18n.t('faq_console_question_add_input_question_placeholder')}
          onChange={updateInputText}
        ></input>
      </div>
    )
  }

  const showQuestion = (counter) => {
    let q = []
    for (let index = 0; index < counter; index++) {
      index === 0 && q.push(question('first'))
      index === 1 && q.push(question('second'))
      index === 2 && q.push(question('third'))
      index === 3 && q.push(question('fourth'))
      index === 4 && q.push(question('fifth'))
    }
    return q
  }

  const addQuestion = (category) => {
    return (
      <div className='question-add-menu'>
        <div className='menu-title'>{I18n.t('dashboard_new-question')}</div>
        {ALLOWED_DOMAINS.type === 'TA' && <div className='menu-header reviewFAQTaNotify'>{questionLabelTextTA}</div>}
        <div className='menu-header'>{questionLabelText}</div>
        <div className='question-add-container'>
          <div className='question-add-section'>
            {showQuestion(counterQuestions.find(it => it.category === category).counter)}
            <div className='error-message'>{errorMessage}</div>
            <div className='add-remove-formulation'>
              {counterQuestions.find(it => it.category === category).counter < totalQuestions &&
                <>
                  <i id={`add-formulation-${category.replace(/\s+|\/|\\|\.|,/g, '')}`}
                    className='fa fa-plus-circle'
                    onClick={() => {
                      let _counterQuestions = _.clone(counterQuestions)
                      _counterQuestions.find(it => it.category === category).counter += 1
                      setCounterQuestions(_counterQuestions)
                    }}
                  />
                  <UncontrolledTooltip placement='top' target={`add-formulation-${category.replace(/\s+|\/|\\|\.|,/g, '')}`}>
                    {I18n.t('dashboard_add-formulation')}
                  </UncontrolledTooltip>
                </>
              }
              {counterQuestions.find(it => it.category === category).counter > initialQuestions &&
                <>
                  <i id={`remove-formulation-${category.replace(/\s+|\/|\\|\.|,/g, '')}`}
                    className='fa fa-minus-circle'
                    onClick={() => {
                      let _counterQuestions = _.clone(counterQuestions)
                      _counterQuestions.find(it => it.category === category).counter -= 1
                      setCounterQuestions(_counterQuestions)
                    }}
                  />
                  <UncontrolledTooltip placement='top' target={`remove-formulation-${category.replace(/\s+|\/|\\|\.|,/g, '')}`}>
                    {I18n.t('dashboard_remove-formulation')}
                  </UncontrolledTooltip>
                </>
              }
            </div>
          </div>
          <div className='answer-add-section'>
            <div className='question-input-container question-input-container--answer'>
              <p className='question-input-container__title'>
                {I18n.t('dashboard_answer')}
              </p>
              {
                flagEnvDisplay.displayMultiLang
                  ? (
                    <LangSelector
                      allowed={botHeader.translationLanguages}
                      onChange={({ value }) => setAnswerLang(value)}
                    />
                  ) : null
              }
            </div>
            <TextEditor2
              id={`answer-${category}`}
              cols={5}
              rows={7}
              company={company}
              limit={0}
              options={["buttons", "emojis", "attachments"]}
              onChange={(e) => {
                const preview = {
                  content: e.value,
                  contentHtml: e.valueHtml,
                  buttons: e.buttons,
                  attachments: e.attachments,
                  removeEmojisAndAccents: e.removeEmojisAndAccents
                }
                setTextPreview({ ...preview })
              }}
              dropZoneFilesHeight={211}
              currentChannelPreview={currentChannelPreview}
              cleanSms
              isTemplateValue
              minHeight={118}
              maxHeight={null}
            />
            <div className={'viewer-wrapper'}>
              <span className='text-preview' onClick={() => setOnPreview(!onPreview)}>
                <li className='fa fa-mobile' />
                {onPreview ? I18n.t('dashboard_close-preview') : I18n.t('dashboard_open-preview')}
              </span>
              <div className='viewer'>{onPreview && <PhoneViewer textPreview={textPreview} setCurrentChannelPreview={setCurrentChannelPreview} />}</div>
            </div>
          </div>
        </div>
        <div className='footer-container'>
          <div className='buttons-container'>
            <FormButton
              secondary
              onClick={() => addNewQuestion(category)}
              value={I18n.t('dashboard_save')}
              isSubmitting={isSubmitting}
            />
            <FormButton
              onClick={() => { setNewQuestionOpen([]); setCounterQuestionsByCategory(stateFaqViewControl) }}
              value={I18n.t('dashboard_cancel')}
            />
          </div>
          <div className='shortcut-container'>
            <div className='title-container'>
              <span className='title'>{I18n.t('dashboard_shortcut')}</span>
            </div>
            <div className='shortcut'>
              <input
                id='funcLetterInput'
                className='letter-input'
                defaultValue=''
                value={funcLetterInput}
                onChange={({ target }) => {
                  setFuncLetterInput(validateShorcutsAV(target.value))
                }}
              />
              <div className='description-container'>
                <div
                  dangerouslySetInnerHTML={{
                    __html: I18n.t('faq_console_shortcut_description')
                  }}
                  className='description-text'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const hideWarningPopup = () => {
    setIsFirstTime(false)
    setPopupTrainIsOpen(false)
    if (notShow) updateBotHeader(botHeader._id, { hideWarningPopup: notShow })
  }

  const downloadFile = (title, avWarnings) => {
    const text = [title]
    text.push(' ')
    if (avWarnings['confusionCases'].length > 0) {
      avWarnings['confusionCases'].forEach((it) => {
        Object.entries(it).forEach(([key, values]) => {
          text.push(I18n.t(`faq_console_confusionCases_faq`).replace('faq_rep', key))

          values.forEach((it2) => (
            text.push(it2)
          ))
        })
      })
      text.push(' ')
    }
    if (avWarnings['highFPRate'].length > 0) {
      text.push(I18n.t(`faq_console_highFPRate`))
      avWarnings['highFPRate'].forEach((it) => {
        text.push(it)
      })
    }

    const pom = document.createElement('a')
    pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text.join('\n')))
    pom.setAttribute('download', 'faqs.txt')

    if (document.createEvent) {
      const event = document.createEvent('MouseEvents')
      event.initEvent('click', true, true)
      pom.dispatchEvent(event)
    }
    else {
      pom.click()
    }
  }

  const getPopupTrain = (value, avWarnings) => {
    let icon = ''

    switch (value) {
      case 'model_with_warnings':
        icon = 'img/icons/icon-warning.svg'
        break
      case 'model_stopped':
        icon = 'img/icons/icon-warning-red.svg'
        break
      default:
        icon = 'img/icons/icon-check.svg'
        break
    }

    if (value === 'no_popup') return null
    return (
      <Collapse className={`popupTrain-wrapper ${value}`} isOpen={popupTrainIsOpen}>
        <div className='seccion-1'>
          <div className={`icon ${value}`}>
            <img src={icon} alt='check' />
          </div>
          <div className='body-text'>
            <div className='wrapper-text'>
              <span className='text'>{I18n.t(`faq_console_${value}`)}</span>
              <div className='close' onClick={hideWarningPopup}>
                <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' />
              </div>
            </div>
            {
              avWarnings &&
              <div className='av-warnings'>
                {avWarnings['confusionCases'].length > 0 &&
                  <>
                    <ul>
                      {
                        avWarnings['confusionCases'].map((it, idx) => {
                          return Object.entries(it).map(([key, values]) => (
                            <div key={idx}>
                              <li>{I18n.t(`faq_console_confusionCases_faq`).replace('faq_rep', key)}</li>

                              {
                                values.map((it2, idx2) => (
                                  <span key={idx2}>{it2}</span>
                                ))
                              }
                            </div>
                          ))
                        })
                      }
                    </ul>
                  </>
                }
                {avWarnings['highFPRate'].length > 0 &&
                  <>
                    <p>{I18n.t(`faq_console_highFPRate`)}</p>
                    <ul>
                      {avWarnings['highFPRate'].map((it, idx) => (
                        <li key={idx}>{it}</li>
                      ))}
                    </ul>
                  </>
                }
              </div>
            }
            <div className='verify'>
              <Checkbox
                id='notShow'
                value={notShow.toString()}
                checked={notShow}
                onChange={(e) => {
                  setNotShow(e.target.checked)
                }}
                label={I18n.t(`dashboard_not-show-again`)}
              />
              {avWarnings && (avWarnings['confusionCases'].length > 0 || avWarnings['highFPRate'].length > 0) &&
                <>
                  <i id={'download-file'} className='fa fa-download' onClick={() => downloadFile(I18n.t(`faq_console_${value}`), avWarnings)} />
                  <UncontrolledTooltip placement='top' target={`download-file`}>
                    {I18n.t('faq_console_tooltip_download_file')}
                  </UncontrolledTooltip>
                </>
              }
            </div>
          </div>
        </div>
      </Collapse>
    )
  }

  const toggleCredentialConfigModal = () => setIsOpenCredentialConfigModal(!isOpenCredentialConfigModal)

  const errorHandler = async (error) => {
    if (axios.isAxiosError(error) && error.response.data.type === 'ecommerce_with_errors') {
      setIsCredentialConfig(true)
      setEcommerceMessageModal('msg_smart_chat_ecommerce_config_credentials')
      toggleCredentialConfigModal()

      return true
    }

    if (error?.data?.message.includes('smartChatEcommerce module is not active')) {
      try {
        await dispatch(moduleActions.add('smartChatEcommerce'))
      } catch(error) {
        return true
      }

      return true
    }

    // Pendiente tipo de error desde AI
    setIsCredentialConfig(false)
    setEcommerceMessageModal('msg_smart_chat_ecommerce_config_smart_chat')
    toggleCredentialConfigModal()

    return true
  }

  const checkSmartChatEcommerceModule = async (botId) => {
    const isActiveNow = !!(smartChatEcommerceModule?.isActive && smartChatEcommerceChecked)

    if (!isActiveNow) {
      try {
        const { data: { onlineShop } } = await SmartChatEcommerceAPI.checkStatusShop()

        await botConsole.updateBotHeader(botId, { eCommerce: true, shopId: onlineShop })
        setSmartChatEcommerceChecked(true)
        await dispatch(moduleActions.add('smartChatEcommerce'))

        await EcommerceAPI.downloadCatalog()
      } catch (error) {
        errorHandler(error)
      }
    } else {
      await botConsole.updateBotHeader(botId, { eCommerce: false })
      setSmartChatEcommerceChecked(false)
    }
  }

  const deleteCategory = async (category) => {
    setCurrentDeleteCategory(category)
    setIsOpenDeleteModal(true)
  }

  return (
    <div id='refContainer'>
      <div className='header'>
        <VACard
          consoleId={botHeader._id}
          updateBotHeader={updateBotHeader}
          checkSmartChatModule={checkSmartChatModule}
          smartChatChecked={smartChatChecked}
          checked={checked}
          setChecked={setChecked}
          generativeChecked={generativeChecked}
          setGenerativeChecked={setGenerativeChecked}
          assistedAIChecked={assistedAIChecked}
          setAssistedAIChecked={setAssistedAIChecked}
          openSchedule={openSchedule}
          getModelStatus={getModelStatus}
          checkSmartChatEcommerceModule={checkSmartChatEcommerceModule}
          smartChatEcommerceChecked={smartChatEcommerceChecked}
          toggleGeneratedResponsesModal={toggleGeneratedResponsesModal}
          companyId={company._id} //@TODO Eliminar tras la subida a PRO del ecommerce
        />
        <TranslateCard
          consoleId={botHeader._id}
          automaticTranslateChecked={automaticTranslateChecked}
          setAutomaticTranslateChecked={setAutomaticTranslateChecked}
          isMultiIntent={isMultiIntent}
          setIsMultiIntent={setIsMultiIntent}
          isGroupable={isGroupable}
          setIsGroupable={setIsGroupable}
          ambiguity={ambiguity}
          setAmbiguity={setAmbiguity}
          updateBotHeader={updateBotHeader}
          toggleTranslationConfigModal={toggleTranslationConfigModal}
          toggleAmbiguityConfigModal={toggleAmbiguityConfigModal}
          defaultProcessId={botHeader.defaultProcessId}
          smartchatProcesses={smartchatProcesses}
          isLoadingProcesses={isLoadingProcesses}
        />
      </div>
      {(
        // intents.find(question => question.trained === false) || hasEditIntents
        hasEditIntents
      ) 
        && !['PENDING', 'ONGOING'].includes(botHeader.modelStatus) 
        && ALLOWED_DOMAINS.type !== 'TA' 
        && (
          <>
            <AVBanner
              className={`${!entry ? 'av-banner-floating' : ''}`}
              title={I18n.t('faq_console_modified_question_title')}
              subtitle={I18n.t('dashboard_apply-changes-train-bot')}
              buttonText={I18n.t('dashboard_apply-changes')}
              buttonAction={openTrainModal}
              isFloating={!entry}
            />
            <div className='intersection-reference' ref={setNode}></div>
          </>
        )}
      {
        getPopupTrain(botHeader.popupTrainResult, botHeader.avWarnings)
      }
      <div className='question-list-content'>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="categories-list" type="COLUMN">
            {(provided_c) => (
              <div
                ref={provided_c.innerRef}
                {...provided_c.droppableProps}
              >
                {stateFaqViewControl.sort((a, b) => { return (a.category === 'none') - (b.category === 'none') }).map((item, index) => (
                  <Draggable
                    key={item.categoryOrder}
                    draggableId={item.categoryOrder.toString()}
                    index={index}
                    isDragDisabled={item.category === 'none' ? true : false}
                  >
                    {(provided_q, snapshot) => (
                      <div
                        id={item.category}
                        ref={provided_q.innerRef}
                        {...provided_q.draggableProps}
                        className='categories-listdp'
                        style={{
                          ...provided_q.draggableProps.style,
                          opacity: snapshot.isDragging ? 0.7 : 1,
                          alignSelf: snapshot.isDragging ? 'flex-end' : 'none',
                        }}
                      >
                        <div className='category-header'>
                          <span className='category-name'>{item.category === 'none' ? I18n.t('dashboard_general') : item.category}</span>
                          <div className={'icons'}>
                            {item.category !== 'none' &&
                              <UncontrolledDropdown direction='right' className='menu-category-details'>
                                <DropdownToggle className={'campaign-export-btn'}>
                                  <i className='fa fa-ellipsis-h' />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    onClick={() => onToggleModalCategory({ mode: 'update', categoryName: item.category })}
                                  >
                                    {I18n.t('dashboard_edit')}
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => deleteCategory(item.category)}
                                  >
                                    {I18n.t('dashboard_delete')}
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            }
                            <i {...provided_q.dragHandleProps} className={`fa fa-bars drag-item ${item.category === 'none' && 'hide'}`} />
                          </div>
                        </div>

                        <Droppable
                          key={item.categoryOrder}
                          droppableId={item.category.replace(/\s+|\/|\\|\.|,/g, '')}
                          type={'QUESTIONS'}
                        >
                          {(provided_q2, snapshot_q2) => (
                            <div
                              ref={provided_q2.innerRef}
                              {...provided_q2.droppableProps}
                              style={{ minHeight: 20, backgroundColor: snapshot_q2.isDraggingOver && '#e2e2e2' }}
                            >
                              {
                                questions.map((q, i) => (
                                  item.intentList.some(it => it === q._id) && (
                                    <Draggable
                                      key={q._id}
                                      draggableId={q._id}
                                      index={item.intentList.findIndex(it => it === q._id)}
                                    >
                                      {(provided_q3) => (
                                        <div
                                          ref={provided_q3.innerRef}
                                          {...provided_q3.draggableProps}
                                          className='draggable-question'
                                        >
                                          <ConsoleQuestion
                                            key={q._id}
                                            question={q}
                                            index={i}
                                            changeQuestionStatus={changeQuestionStatus}
                                            editQuestionOpen={questionsOpened[i]}
                                            openEditQuestion={openEditQuestion}
                                            deleteQuestion={deleteQuestion}
                                            removing={removing}
                                            inputContentChanged={inputContentChanged}
                                            updateIntent={updateIntent}
                                            company={company}
                                            checkShortcut={checkShortcut}
                                            handleDragAndDrop={provided_q3.dragHandleProps}
                                            translationLanguages={botHeader.translationLanguages}
                                          />
                                        </div>
                                      )}
                                    </Draggable>
                                  )
                                ))
                              }
                              {provided_q2.placeholder}
                            </div>
                          )}
                        </Droppable>

                        <>
                          {newQuestionOpen.some(it => it === item.category) ? (
                            addQuestion(item.category)
                          ) : (
                            <Button
                              outline
                              className='add-question-button'
                              color='primary'
                              size='lg'
                              onClick={() => {
                                setNewQuestionOpen(newQuestionOpen.concat(item.category))
                                let newQuestionOpened = new Array(questionsOpened.length).fill(false)
                                setQuestionsOpened(newQuestionOpened)
                              }}
                            >
                              <i className='fa fa-plus-circle' />{I18n.t('dashboard_add-question')}
                            </Button>
                          )}
                        </>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided_c.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      <Button
        outline
        className='add-category-button'
        color='#777777'
        size='lg'
        onClick={() => onToggleModalCategory({ mode: 'add' })}
      >
        <i className='fa fa-plus-circle mr-2' />
        {I18n.t('dashboard_add-category')}
      </Button>
      <ModalWrapper
        isOpen={isOpenSmartChatHealtModal}
        toggle={toggleSmartChatHealthModal}
        header={' '}
        body={
          <div className='modal-content'>
            <p>{I18n.t(smartChatHealtInfo)}</p>
          </div>
        }
        eventBtnTxt={I18n.t('dashboard_close')}
        eventBtn={toggleSmartChatHealthModal}
      />
      {showModalCategory && (
        <CategoryModal
          mode={categoryModalMode}
          isOpen={showModalCategory}
          toggle={() => onToggleModalCategory({})}
          data={{
            categories: stateFaqViewControl,
            categoryForEdit
          }}
          save={value => {
            let order = stateFaqViewControl.reduce((p, v) => Math.max(p.categoryOrder, v.categoryOrder) === v.categoryOrder ? v : p)
            let _stateFaqViewControl = _.clone(stateFaqViewControl)

            if (categoryModalMode === 'add') {
              _stateFaqViewControl.unshift({ category: value, categoryOrder: order - 1, intentList: [] })
              _stateFaqViewControl.sort((a, b) => a.categoryOrder - b.categoryOrder).map((it, index) => it.categoryOrder = index)
            }
            if (categoryModalMode === 'update') {
              const categoryIndex = _stateFaqViewControl.findIndex(({ category }) => category === categoryForEdit)
              _stateFaqViewControl = Object.assign([..._stateFaqViewControl], {
                [categoryIndex]: {
                  ..._stateFaqViewControl[categoryIndex],
                  category: value
                }
              })
            }

            updateBotHeader(botHeader._id, { faqViewControl: _stateFaqViewControl })
            setTimeout(() => {
              onToggleModalCategory({})
              setGoToTop(true)
            })
          }}
        />
      )}

      <SmartChatActivationModal
        isOpen={isOpenSmartChatActivationModal}
        toggle={toggleOpenSmartChatActivationModal}
        onEvent={toggleActivateSmartChat}
      />

      {modal ? <div className='modal-background'>{getModal()}</div> : null}

      {isOpenTranslationConfigModal && (
        <TranslationConfigModal
          isOpen={isOpenTranslationConfigModal}
          toggle={toggleTranslationConfigModal}
          consoleId={botHeader._id}
          translationLanguages={botHeader.translationLanguages}
          updateBotHeader={updateBotHeader}
        />
      )}

      {isOpenAmbiguityConfigModal && (
        <AmbiguityConfigModal
          isOpen={isOpenAmbiguityConfigModal}
          toggle={toggleAmbiguityConfigModal}
          consoleId={botHeader._id}
          ambiguityText={botHeader.ambiguity_text}
          updateBotHeader={updateBotHeader}
        />
      )}

      <CredentialsConfigModal
        isOpen={isOpenCredentialConfigModal}
        toggle={toggleCredentialConfigModal}
        message={ecommerceMessageModal}
        isCredentialConfig={isCredentialConfig}
      />

      <ModalDelete
        isOpen={isOpenDeleteModal}
        toggle={() => setIsOpenDeleteModal(!isOpenDeleteModal)}
        header={I18n.t('botConsole_remove_category')}
        text1={I18n.t('botConsole_remove_category_title')}
        text2={I18n.t('botConsole_remove_category_legend')}
        categoryToDelete={currentDeleteCategory}
        event={() => {
          let intents = stateFaqViewControl.find(it => it.category === currentDeleteCategory).intentList
          let _stateFaqViewControl = stateFaqViewControl.filter(it => it.category !== currentDeleteCategory)
          _stateFaqViewControl.sort((a, b) => a.categoryOrder - b.categoryOrder)
          _stateFaqViewControl.map((it, index) => it.categoryOrder = index)
          intents.map(intent => _stateFaqViewControl.find(it => it.category === 'none').intentList.push(intent))
          setStateFaqViewControl(_stateFaqViewControl)
          updateBotHeader(botHeader._id, { faqViewControl: _stateFaqViewControl })
          setIsOpenDeleteModal(!isOpenDeleteModal)
        }}
        isSubmitting={removing}
        errorMessage={errorMessage}
      />

      {isOpenGeneratedResponsesModal ? (
        <GeneratedResponsesModal
          isOpen={isOpenGeneratedResponsesModal}
          toggle={toggleGeneratedResponsesModal}
          consoleId={botHeader._id}
        />
      ) : null}
    </div>
  )
}

export default AssistantView
